import { useMutation } from '@tanstack/react-query'
import { createTextVideo } from '../../service/list'

function useCreateTextVideo() {
  return useMutation({
    mutationKey: ['create-text-video'],
    mutationFn: createTextVideo,
  })
}

export default useCreateTextVideo
